import React from 'react';
import Helmet from 'react-helmet';
import { withTranslation } from 'react-i18next';
import companyName from '../../../store/mobxStore/companyName';
import { withRouter } from 'react-router';
import PageTitle from '../../components/common/pageTitle';
import EditnAddBusinessHere from '../../components/dashboard/EditnAddBusiness';
import { COMPANY_NAME } from '../../../configuration/apiconfig';


function BusinessView({t}) {

     return (
            <div className="h-100">
            <Helmet>
                <title>{companyName.companyName} | Add/Edit Business</title>
            </Helmet>
             <PageTitle title="addeditbusiness" buttonOn={false} />
             <EditnAddBusinessHere/>
             </div>
     )
}
export default withTranslation()(withRouter(BusinessView))
